import React, { useState, useEffect } from "react";
import 'chart.js/auto';
import { Doughnut } from 'react-chartjs-2';
import { getCurrentDate } from "../../helpers/utils.js";
import useAxios from "../../helpers/useAxios";

const Distribuicao = (props) => {
  const [dataGraph, setDataGraph] = useState(null);

  const { data, error, loaded } = useAxios("POST", "/Funds/funds-distribution", { nif: props.nif });

  const options = {
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          boxWidth: 15,
          boxHeight: 15,
          padding: 10,
       },
      },
    },
    cutout: 62,
    maintainAspectRatio: false,
  };

  const colors = ['#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF', '#0071CE', '#003E71', '#6EB5FF'];

  useEffect(() => {      
    if (loaded && error.length === 0) {
      let labels = data.funds;

      const newData = {
        labels,
        datasets: [
          {
            data: data.price,
            backgroundColor: colors,
          },     
        ],
      };

      setDataGraph(newData)
    }
  }, [data]);

  return (
    <div className="col-md-6 mb-4 col-eq-h">
      <div className="col-md-12 bg-white rounded-4 p-3">
        <h3 className="mb-4">Distribuição</h3>
          {!loaded && (
        <div className="text-center mt-5">
          <div className="spinner-border text-blue" role="status">
          </div>
        </div>
       )}
          {dataGraph && (
            <div className="position-relative" style={{height:225}}>
              <div className="info-graph">
                <div className="info-graph-value">{props.value} €</div>
                {getCurrentDate()}
              </div>
              <Doughnut options={options} data={dataGraph} />
            </div>
          )}
      </div>
    </div>
  );
};

export default Distribuicao;
